import { Component, ElementRef, HostListener, Injectable, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BehaviorSubject, debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import Swal from 'sweetalert2';
import { ModalContentComponent } from '../../model/modal-content/modal-content.component';
import { UtilService } from './../../../services/util.service';
import { NetworkCardComponent } from '../../../components/cards/network-card/network-card.component';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { WidgetModule } from '../../../widget/widget.module';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-network',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, FormsModule, InfiniteScrollModule, CommonSkeletonComponent, NodataFoundComponent, WidgetModule,
NetworkCardComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './network.component.html',
  styleUrls: ['./network.component.scss']
})
export class NetworkComponent implements OnInit, OnDestroy {

  @ViewChild('landingside1') menuElement: ElementRef;
  landingsidesticky1: boolean = false;
  landingsidesticky2: boolean = false;
  elementPosition: any;
  bsModalRef: BsModalRef;
  networkdata: any = [];
   connectionlistuserdata: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  userType: any = localStorage.getItem('userType');
  temp: any = [];
  noDatafound: Array<string> = ["No data to display"];
  noDataInReqReceived: Array<string> = ["You have no requests received lately"];
  showNoDatafound: boolean = false;
  networkSearch: string;
  btnnameshow:string="All";
  allNetwork: boolean = false;
  requestNetwork: boolean = false;

  search: any;
  netlist: string;
  searchKey
  prevAfterkey = null;
  subscriber: Subscription;
  /** In-flight network/home request — dropped when a new filter/search starts. */
  networkSubscription: Subscription;
  loadAPIcall:boolean=false;
  deactivateNetwork: boolean =false;
  searchContent: string="";
  searchSubject = new Subject<string>();
  count: number = 0;
  stopScroll : boolean = false;

  activeFilter: string | null = null;

  constructor(
    private api: ApiService,
    private util: UtilService,
    private modalService: BsModalService,
    private route: ActivatedRoute, ) {
  }
  ngOnInit() {
    if (
      this.route.queryParams["_value"].routeFrom != "" &&
      this.route.queryParams["_value"].routeFrom != undefined &&
      this.route.queryParams["_value"].routeFrom != null) {
      this.querynetwork("PENDING");
      this.activeFilter = 'PENDING';
    } else {
      this.querynetwork(null);
      this.activeFilter = null;
    }
     this.searchSubject.pipe(
          debounceTime(500),
          distinctUntilChanged(),
        )
          .subscribe(
            res => {

              this.updateSearch();
            }
          )

  }


  status: string | null = null;

  payload: any = {
    limit: 12,
    page: 0,
    userId: localStorage.getItem('userId'),
    searchAfterKey: null,
    status: null,
    searchContent: null
  };

  filterstatus(status: string | null): void {
    this.activeFilter = status;
    this.payload.searchAfterKey = null;
    this.payload.searchContent = "";
    this.searchContent = '';
    this.count = 0;
    this.stopScroll = false;
    this.prevAfterkey = null;
    this.connectionlistuserdata.next([]);
    this.querynetwork(status);
  }


querynetwork(filter: string | null): void {
  this.loadAPIcall = true;
  this.payload.status = filter;
  this.status = filter;
  this.activeFilter = filter;

  // Clear previous data and reset pagination for a new search
  if (this.payload.searchContent && this.payload.searchAfterKey === null) {
    this.connectionlistuserdata.next([]);
    this.prevAfterkey = null;
    this.stopScroll = false;
  }

  let noData: string[] = [];
  if (this.status === 'ACTIVE') {
    this.btnnameshow = 'Active Networks';
    noData = this.searchContent !== "" ? ['No data available!'] : ['No data to display'];
  } else if (this.status === 'DEACTIVATED') {
    this.btnnameshow = 'Deactive Network';
    noData = this.searchContent !== "" ? ['No data available!'] : ['No data to display'];
  } else if (this.status === 'INACTIVE') {
    this.btnnameshow = 'Deactive Networks';
    noData = this.searchContent !== "" ? ['No data available!'] : ['No data to display'];
  } else if (this.status === 'PENDING') {
    this.btnnameshow = 'Requests Received';
    noData = this.searchContent !== "" ? ['No data available!'] : ['No data to display'];
  } else if (this.status === null && !this.searchContent) {
    this.btnnameshow = "All";
    noData = ['No data to display'];
  } else if (this.searchContent !== "") {
    noData = ['No data available!'];
  }

  // Latest call wins. Clicking filters quickly used to leave several
  // network/home requests racing; drop the in-flight one first.
  this.networkSubscription?.unsubscribe();
  this.networkSubscription = this.api.create("network/home", this.payload).subscribe({
    next: (res) => {
      // The stale-response check MUST come before clearing loadAPIcall. It used
      // to run after, so a response for the filter the user had already clicked
      // past switched the skeletons off and returned without setting
      // showNoDatafound — the middle column then rendered nothing, and because
      // these columns are floats, a zero-height column reserves no space and the
      // widgets jumped to the left until the current request landed.
      if (this.activeFilter !== filter) {
        return;
      }
      this.loadAPIcall = false;

      if (res?.data?.totalElements === 0) {
        this.stopScroll = true;
      }

      if (res?.data?.network != null) {
        const resData = res.data.network;
        const afterKey = res.data.searchAfterKey;

        if (resData) {
          const existingData = this.connectionlistuserdata.getValue();
          const existingIds = new Set(existingData.map(item => item.networkId));

          const filteredData = resData.filter(item => !existingIds.has(item.networkId));

          if (filteredData.length > 0) {
            const updatedData = [...existingData, ...filteredData];
            this.connectionlistuserdata.next(updatedData);
          }

          // Stop scrolling if no new data is fetched
          if (JSON.stringify(this.prevAfterkey) === JSON.stringify(afterKey) || filteredData.length === 0) {
            this.stopScroll = true;
          }

          this.prevAfterkey = afterKey; // Update pagination key

          if (res.data.totalElements !== undefined) {
            this.count = res.data.totalElements;
          }
        }
      }

      this.showNoDatafound = this.connectionlistuserdata.getValue().length === 0;
      this.noDatafound = this.showNoDatafound ? noData : [];
    },
    error: (err) => {
      this.util.stopLoader();
      if (this.activeFilter !== filter) {
        return;
      }
      // Was left true, so a failed request kept the skeletons on screen for good.
      // End on the empty-state message instead.
      this.loadAPIcall = false;
      this.showNoDatafound = this.connectionlistuserdata.getValue().length === 0;
      this.noDatafound = this.showNoDatafound ? noData : [];
    }
  });
}


ngOnDestroy(): void {
  // Leaving the page mid-request used to leave the handler running.
  this.networkSubscription?.unsubscribe();
}

onScrollDown(): void {

  if (this.prevAfterkey != undefined && JSON.stringify(this.payload.searchAfterKey) != JSON.stringify(this.prevAfterkey)) {
      this.payload.searchAfterKey = (this.prevAfterkey && this.prevAfterkey.length === 0) ? null : this.prevAfterkey;
      this.querynetwork(this.status);
  }
}





  letterCaps(name: string): string {
    if (!name) {
      return '';
    }

    const capitalizedPhrase = name
      .split(' ')
      .map(word => word[0].toUpperCase() + word.slice(1))
      .join(' ');

    return capitalizedPhrase;
  }
  updateSearch() {
    this.payload.searchContent = this.searchContent.trim() !== "" ? this.searchContent.trim() : null;
    this.payload.searchAfterKey = null;
    this.stopScroll = false;
    this.count=0
    this.connectionlistuserdata.next([]);
     this.querynetwork(this.status);
  }

  keyupdata(value : string) {
    this.searchSubject.next(value);
  }



  ngAfterViewInit() {
    window.scrollTo(0, 0);
    // this.elementPosition = this.menuElement.nativeElement.offsetTop;
  }

  @HostListener('window:scroll')
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 24) {
      this.landingsidesticky1 = true;
      this.landingsidesticky2 = true;
    } else {
      this.landingsidesticky1 = false;
      this.landingsidesticky2 = false;
    }
  }


  move_focus(e) {
    if (e.keyCode == 13) $("#my_btn").focus();
  }



  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    }
  }




  filterByString(data, s) {
    return data.filter(e => e.networkName.toLowerCase().includes(s))
      .sort((a, b) => a.networkName.toLowerCase().includes(s) && !b.networkName.toLowerCase().includes(s) ? -1 : b.networkName.toLowerCase().includes(s) && !a.networkName.toLowerCase().includes(s) ? 1 : 0);
  }

  async openModalWithComponent() {

    this.api.query("network/findUserOwnedNetwroks?userId="+localStorage.getItem('userId')+"&&status=ACTIVE").subscribe(res=>{


      if(res.code=="00000"){

        if(res.data.networks.length!=0){
          Swal.fire({
            icon: "info",
            title: "Network already created. Only one network allowed.",
            showConfirmButton: false,
            timer: 4000,
          });
        }else if(res.data.networks.length==0){
          const initialState: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            size: "open"
          };
          this.bsModalRef = this.modalService.show(ModalContentComponent, initialState);
          this.bsModalRef.content.closeBtnName = 'Close';
        }

      }

    })
  }

  apicall(data) {
    this.util.startLoader();
    let datas: any = {};
    datas.memberUserId = localStorage.getItem('userId');
    // datas.networkId =   networkId;
    this.api.create("network/member/save", datas).subscribe(res => {
      this.util.stopLoader();
    }, err => {
      this.util.stopLoader();
      if (err.status == 500) {
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'Something went wrong while processing you request. Please, try again later.',
          showDenyButton: false,
          confirmButtonText: `ok`,
        })
      }
    });
  }


  onSubmit(data : string){
    if (data === GigsumoConstants.SUCESSCODE) {
        // Reload PENDING networks to update the count
      if (this.activeFilter === 'PENDING' || this.activeFilter === null) {
      this.payload.searchAfterKey=null;
      this.searchContent="";
      this.prevAfterkey=null;
      this.stopScroll=false;
      this.connectionlistuserdata.next([]);
      this.count = 0;
      this.querynetwork(this.activeFilter);// Reloads the current page without routing
        }
    }
  }


}


